import { ApiClient } from "./api-client";

export function getInformationPages() {
  return ApiClient.getInstance().get('/information-page').catch((error) => {
    console.error('Error fetching information pages:', error);
    throw error;
  });
}

export function getInformationPageContent(id) {
  return ApiClient.getInstance().get(`/information-page/${id}`).catch((error) => {
    console.error('Error fetching information page content:', error);
    throw error;
  });
}

export function createInformationPage(title, content) {
  return ApiClient.getInstance().post('/information-page', { title, content }).catch((error) => {
    console.error('Error creating information page:', error);
    throw error;
  });
}

export function updateInformationPage(id, title, content) {
  return ApiClient.getInstance().put('/information-page', { id, title, content }).catch((error) => {
    console.error('Error updating information page:', error);
    throw error;
  });
}

export function deleteInformationPage(id) {
  return ApiClient.getInstance().delete(`/information-page/${id}`).catch((error) => {
    console.error('Error deleting information page:', error);
    throw error;
  });
}

export function moveUpInformationPage(id) {
  return ApiClient.getInstance().put(`/information-page/move-up/${id}`).catch((error) => {
    console.error('Error moving up information page:', error);
    throw error;
  });
}

export function moveDownInformationPage(id) {
  return ApiClient.getInstance().put(`/information-page/move-down/${id}`).catch((error) => {
    console.error('Error moving down information page:', error);
    throw error;
  });
}